import React from 'react';
import { ReactNode } from "react";
import { Navbar, Nav, Container } from 'react-bootstrap';
import { IMetricsRowData, IToolTip } from "../App_v01_Interfaces";
import { OverlayTrigger, Tooltip, Button, ButtonToolbar } from 'react-bootstrap';

interface IMetricsRowDataProps{
  metricsRowData: IMetricsRowData;
  cssValue?:number;
}//end:

// const tooltipObj:ReactNode (titleText:string) => {
//     return(
//         <Tooltip id="tooltip">
//             {titleText}
//         </Tooltip>
//     )
// }
  
// const tooltipObj = (titleText: string): ReactNode => {
//   return (
//     <Tooltip id="tooltip">
//       {titleText}
//     </Tooltip>
//   );
// };

const tooltipObj = (text: string) => (
  <Tooltip id="tooltip">{text}</Tooltip>
);

const MetricsRow_v01: React.FC<IMetricsRowDataProps> = ({metricsRowData, cssValue}) => {
  

{/* 
    <button type="button" class="btn btn-secondary"
        data-bs-toggle="tooltip" data-bs-placement="top"
        data-bs-custom-class="custom-tooltip"
        data-bs-title="This top tooltip is themed via CSS variables.">
        Custom tooltip
    </button> 
*/}





  return (
                <div className="container-fluid text-center mt-1 mb-1 metricsRow">
                

                <div className="row my-border-bottom">
                    <div className='col-12'>
                        <h2 className="metricsTitle flash-shadow">{metricsRowData.Headline}</h2>

                    </div> 
                </div>

 
                <div className="row fw-bold">
                    <OverlayTrigger placement="top" overlay={tooltipObj(metricsRowData.Rows[0].SubTitle)}>
                        <div className="col-12 col-sm-6 col-md-3 rounded zoomText">
                            <div className="row">
                                <div className="col">
                                    {/* <span style={{fontSize:'4em'}}>{metricsRowData.Rows[0].Title}</span> */}

                                    <span className={"metric-title"+cssValue} >{metricsRowData.Rows[0].Title}</span>     
                                    
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <span className={"metric-value"+cssValue}>{metricsRowData.Rows[0].Text}</span>
                                </div>
                            </div>
                        </div>
                    </OverlayTrigger>
                    



                <OverlayTrigger placement="top" overlay={tooltipObj(metricsRowData.Rows[1].SubTitle)}>
                    <div className="col-12 col-sm-6 col-md-3 zoomText">
                        <div className="row">
                            <div className="col">
                                <span className={"metric-title"+cssValue}>{metricsRowData.Rows[1].Title}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className={"metric-value"+cssValue}>{metricsRowData.Rows[1].Text}</span>
                            </div>
                        </div>
                    </div>
                </OverlayTrigger>



                <OverlayTrigger placement="top" overlay={tooltipObj(metricsRowData.Rows[2].SubTitle)}>
                    <div className="col-12 col-sm-6 col-md-3 zoomText">
                        <div className="row">
                            <div className="col">
                                <span className={"metric-title"+cssValue}>{metricsRowData.Rows[2].Title}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                               <span className={"metric-value"+cssValue}>{metricsRowData.Rows[2].Text}</span>
                            </div>
                        </div>
                    </div>
                </OverlayTrigger>

                <OverlayTrigger placement="top" overlay={tooltipObj(metricsRowData.Rows[3].SubTitle)}>
                    <div className="col-12 col-sm-6 col-md-3 zoomText">
                        <div className="row">
                            <div className="col">
                                <span className={"metric-title"+cssValue}>{metricsRowData.Rows[3].Title}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                               <span className={"metric-value"+cssValue}>{metricsRowData.Rows[3].Text}</span>
                            </div>
                        </div>
                    </div>
                </OverlayTrigger>

            </div>
        </div>

  );
};


export default MetricsRow_v01;




  // <div className="container text-center mt-5 mb-5">
        //     <div className="row">
        //         <div className='col-12'>
        //             <h2>{metricsRowData.Headline}</h2>
        //         </div> 
        //     </div>

        //     <div className="row">
        //         <div className="col">
        //             <span  data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" data-bs-title="This top tooltip is themed via CSS variables." style={{fontSize:'4em'}}>{metricsRowData.Rows[0].Title}</span>
        //         </div>

        //         <div className="col">
        //             <span title={metricsRowData.Rows[1].SubTitle} style={{fontSize:'4em'}}
        //                 className="top" 
        //                 data-placement="top" 
        //                 data-toggle="tooltip" 
        //                 data-original-title="Tooltip on top"
                        
        //             >{metricsRowData.Rows[1].Title}</span>
        //         </div>


        //         <div className="col">
                    

        //              <OverlayTrigger
        //                 placement="top"
        //                 overlay={
        //                             <Tooltip id="tooltip-top">
        //                             This is a tooltip!
        //                             </Tooltip>
                            
        //                         }>



        //                         <span title={metricsRowData.Rows[2].SubTitle} style={{fontSize:'4em'}}>{metricsRowData.Rows[2].Title}</span>

        //                         </OverlayTrigger>


        //         </div>
        //         <div className="col">
        //             <span title={metricsRowData.Rows[3].SubTitle} style={{fontSize:'4em'}}>{metricsRowData.Rows[3].Title}</span>
        //         </div>
        //     </div>

        
        //     <div className="row">
        //         <div className="col">
        //             <span style={{fontSize:'4em'}}>{metricsRowData.Rows[0].Text}</span>
        //         </div>
        //         <div className="col">
        //             <span style={{fontSize:'4em'}}>{metricsRowData.Rows[1].Text}</span>
        //         </div>
        //         <div className="col">
        //             <span style={{fontSize:'4em'}}>{metricsRowData.Rows[2].Text}</span>
        //         </div>
        //         <div className="col">
        //             <span style={{fontSize:'4em'}}>{metricsRowData.Rows[3].Text}</span>
        //         </div>
        //     </div>


        // </div>